import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { AiFillStar } from "react-icons/ai";
import { FiArrowLeft } from 'react-icons/fi';

import './styles.css';

import FeedLayout from '../Includes/FeedLayout';
import api from '../../services/api';

import went_down from '../../assests/went_down.png';
import went_up from '../../assests/went_up.png';
import didnt_move from '../../assests/didnt_move.png';
import { useTranslation } from 'react-i18next';
import NomeFrigorifico from '../Ranking/NomeFrigorifico';

export default function RankingDetalhe(props) {
  const history = useHistory();
  const ID = parseInt(props.match.params.id);
  const USER_EMAIL = sessionStorage.getItem('email');
  const USER_TOKEN = sessionStorage.getItem('token');
  const [frig, setFrig] = useState([]);
  const [cidade, setCidade] = useState([]);
  const [estado, setEstado] = useState([]);
  const [one_stars, setOneStars] = useState(0);
  const [two_stars, setTwoStars] = useState(0);
  const [three_stars, setThreeStars] = useState(0);
  const [four_stars, setFourStars] = useState(0);
  const [five_stars, setFiveStars] = useState(0);
  const [media1, setMedia1] = useState(0);
  const [media2, setMedia2] = useState(0);
  const [media3, setMedia3] = useState(0);
  const [media4, setMedia4] = useState(0);
  const [media5, setMedia5] = useState(0);
  const [totalStars, setTotalStars] = useState(0);
  const { t } = useTranslation();

  function voltar() {
    history.goBack();
  }

  useEffect(() => {
    api.get(`/v5/fridges/${ID}`, {
      headers: {
        USER_EMAIL,
        USER_TOKEN,
      }
    }).then(response => {
      const data = response.data || {};
      const one = parseFloat(data.one_stars) || 0;
      const two = parseFloat(data.two_stars) || 0;
      const three = parseFloat(data.three_stars) || 0;
      const four = parseFloat(data.four_stars) || 0;
      const five = parseFloat(data.five_stars) || 0;
      const total = parseFloat(data.evaluations_count) || 0;
      const fmt = (n) => Intl.NumberFormat('pt-br', {
        style: 'decimal',
        minimumFractionDigits: 1,
        maximumFractionDigits: 1,
      }).format(n);

      setFrig(data);
      setCidade(data.city || {});
      setEstado(data.state || {});
      setOneStars(one);
      setTwoStars(two);
      setThreeStars(three);
      setFourStars(four);
      setFiveStars(five);
      setTotalStars(total);
      setMedia1(fmt(total > 0 ? (one / total * 100) : 0));
      setMedia2(fmt(total > 0 ? (two / total * 100) : 0));
      setMedia3(fmt(total > 0 ? (three / total * 100) : 0));
      setMedia4(fmt(total > 0 ? (four / total * 100) : 0));
      setMedia5(fmt(total > 0 ? (five / total * 100) : 0));
    }).catch(err => {
      const status = err.response && err.response.status;
      if (status === 401) {
        history.push('/');
      }
    });
  }, [ID, USER_EMAIL, USER_TOKEN, history]);
  return (
    <FeedLayout active="ranking">
    <div className="rankingdet-container">
      <div className="feed-top">
        <button type="button" className="btn-voltar" onClick={voltar}>
          <FiArrowLeft size={18} /> {t('pages.rankingDetails.buttons.goBack')}
        </button>
        <span className="feed-top-title"><NomeFrigorifico name={frig.name} /></span>
      </div>
      <section className="body">
        <ul>
          <li>
            <p className="media-geral">{(cidade && cidade.name) || ''} / {(estado && estado.acronym) || ''}</p>
            <p className="media-geral"> {t('pages.rankingDetails.overalAverage')} </p>
            <p className="media">{Intl.NumberFormat('pt-br', { style: 'decimal', minimumFractionDigits: 1, maximumFractionDigits: 1 }).format(frig.evaluation_average)}</p>
            <p className="mediabois"> {t('pages.rankingDetails.maleAverage')} {Intl.NumberFormat('pt-br', { style: 'decimal', minimumFractionDigits: 1, maximumFractionDigits: 1 }).format(frig.male_average)}</p>
            <p className="mediabois"> {t('pages.rankingDetails.femaleAverage')} {Intl.NumberFormat('pt-br', { style: 'decimal', minimumFractionDigits: 1, maximumFractionDigits: 1 }).format(frig.female_average)}</p>
            <p className="media-geral"> {t('pages.rankingDetails.avaliations')} </p>
            <p className="stars"><AiFillStar /><AiFillStar /><AiFillStar /><AiFillStar /><AiFillStar /> {media5}% {t('pages.rankingDetails.avaliation')} </p>
            <p className="stars"><AiFillStar /><AiFillStar /><AiFillStar /><AiFillStar />  {media4}% {t('pages.rankingDetails.avaliation')} </p>
            <p className="stars"><AiFillStar /><AiFillStar /><AiFillStar />  {media3}% {t('pages.rankingDetails.avaliation')} </p>
            <p className="stars"><AiFillStar /><AiFillStar />  {media2}% {t('pages.rankingDetails.avaliation')} </p>
            <p className="stars"><AiFillStar /> {media1}% {t('pages.rankingDetails.avaliation')} </p>
          </li>
        </ul>
      </section>
      <section className="paginacao">
        <button type="button" className="btn-voltar" onClick={voltar}>
          <FiArrowLeft size={18} /> {t('pages.rankingDetails.buttons.goBack')}
        </button>
      </section>
    </div>
    </FeedLayout>
  )
}